import { c as _c } from "react/compiler-runtime";
import { useTheme } from '@classify/react-core-components/styles';
import { useMediaQuery } from '@mui/material';
import { Breakpoint } from '../types/Breakpoint';
type ChoosableBreakpointItem<T> = {
  value: T;
  breakpoint: Breakpoint;
};
type ChoosableItem<T> = {
  value: T;
  condition: boolean;
};
function getFirstVerifiedValue<T>(items: ChoosableItem<T>[]): T | void {
  return items.find(({
    condition
  }) => condition)?.value;
}
function useChooseValueFromBreakpoint(items) {
  const $ = _c(17);
  const {
    breakpoints
  } = useTheme();
  let t0;
  if ($[0] !== breakpoints) {
    t0 = breakpoints.up("xs");
    $[0] = breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = useMediaQuery(t0);
  let t2;
  if ($[2] !== breakpoints) {
    t2 = breakpoints.up("sm");
    $[2] = breakpoints;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = useMediaQuery(t2);
  let t4;
  if ($[4] !== breakpoints) {
    t4 = breakpoints.up("md");
    $[4] = breakpoints;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = useMediaQuery(t4);
  let t6;
  if ($[6] !== breakpoints) {
    t6 = breakpoints.up("lg");
    $[6] = breakpoints;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = useMediaQuery(t6);
  let t8;
  if ($[8] !== breakpoints) {
    t8 = breakpoints.up("xl");
    $[8] = breakpoints;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = useMediaQuery(t8);
  let t10;
  if ($[10] !== items || $[11] !== t1 || $[12] !== t3 || $[13] !== t5 || $[14] !== t7 || $[15] !== t9) {
    const breakpointsMap = {
      xs: t1,
      sm: t3,
      md: t5,
      lg: t7,
      xl: t9
    };
    t10 = getFirstVerifiedValue(items.map(t11 => {
      const {
        value,
        breakpoint
      } = t11;
      return {
        value,
        condition: breakpointsMap[breakpoint]
      };
    }));
    $[10] = items;
    $[11] = t1;
    $[12] = t3;
    $[13] = t5;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}
export default useChooseValueFromBreakpoint;